import * as Sentry from "@sentry/gatsby"
import { CaptureContext } from "@sentry/types"
import { getCachedUser } from "./cached-user"

export const captureException = (
  exception: any,
  captureContext?: CaptureContext | undefined
) => {
  if (process.env.GATSBY_NODE_ENV === "development") {
    console.log("Logging error to sentry!")
    console.log(exception)
  } else {
    const session_id = getCachedUser()?.session_id ?? ""
    Sentry.captureException(exception, {
      ...captureContext,
      tags: {
        ...(captureContext as any)?.tags,
        version: process.env.GATSBY_APP_VERSION,
        ...(session_id && { sessionId: session_id }),
      },
    })
  }
}
